import {
  Col, Row, Tabs,
} from 'antd';
import React, { FC } from 'react';
import { getContextStores } from '../../../../context';
import styles from './styles.module.less';
import PlannedTwinIDPropertiesTable from './PlannedTwinIDPropertiesTable';
import PlannedTwinIDPropertiesDiffTable from './PlannedTwinIDPropertiesDiffTable';

const Summary: FC = () => {
  /* Context */
  const contextStores = getContextStores();
  const { plannedTwinIDUpdateState } = contextStores;
  const { plannedUpdatedPlannedTwinID } = plannedTwinIDUpdateState || {};
  const {
    unchanged,
    create,
    delete: deleteCount,
  } = plannedUpdatedPlannedTwinID || {};

  const updateByTwinID = plannedUpdatedPlannedTwinID?.updateByTwinID || 0;

  const summaryTabItems = [
    {
      label: `Create (${create || 0})`,
      key: '2',
      children: <PlannedTwinIDPropertiesTable updatesKey="created" />,
    },
    {
      label: `Delete (${deleteCount || 0})`,
      key: '3',
      children: <PlannedTwinIDPropertiesTable updatesKey="deleted" />,
    },
    {
      label: `Update by Twin ID (${updateByTwinID || 0})`,
      key: '5',
      children: <PlannedTwinIDPropertiesDiffTable />,
    },
    {
      label: `Unchanged (${unchanged || 0})`,
      key: '6',
      disabled: true,
    },
  ];

  return (
    <Col>
      <Row>
        <div className={styles.tabItem}>
          <Tabs
            tabPosition="left"
            defaultActiveKey="1"
            items={summaryTabItems}
          />
        </div>
      </Row>
    </Col>
  );
};

export default Summary;
